export default function ArticleFooter() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <button 
          onClick={scrollToTop}
          className="inline-block bg-white border-2 border-teal-500 text-teal-600 px-8 py-3 rounded-lg font-bold hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap"
        >
          TOPに戻る
        </button>
      </div>
    </div>
  );
}
